export const Url = {
  local: 'https://gestor.chevyplan.com.co:8101',
  prod: 'hhttps://gestor.chevyplan.com.co:8101',
  qa: 'https://gestor.chevyplan.com.co:8101',
  chevy: 'https://gestor.chevyplan.com.co:8101',
  EncryptKey: 1203199320052021,
  EncryptIV: 1203199320052021,
  encryption:true ,
  FERIADOS_COLOMBIA: [
    { "day": 1, "month": 1 },
    { "day": 6, "month": 1 },
    { "day": 24, "month": 3 },
    { "day": 13, "month": 4 },
    { "day": 17, "month": 4 },
    { "day": 18, "month": 4 },
    { "day": 20, "month": 4 },
    { "day": 1, "month": 5 },
    { "day": 2, "month": 6 },
    { "day": 15, "month": 6 },
    { "day": 23, "month": 6 },
    { "day": 30, "month": 6 },
    { "day": 7, "month": 8 },
    { "day": 18, "month": 8 },
    { "day": 13, "month": 10 },
    { "day": 3, "month": 11 },
    { "day": 17, "month": 11 },
    { "day": 8, "month": 12 },
    { "day": 25, "month": 12 }
  ]
}

